import { theme } from "@/styles/theme";
import { Flex, FlexProps, useMantineColorScheme } from "@mantine/core";

export const DetailHeader = (params: FlexProps) => {
  const { children } = params;
  const { colorScheme } = useMantineColorScheme();
  return (
    <Flex
      p={"16px 32px"}
      direction={"column"}
      align={"flex-start"}
      gap={8}
      bg={colorScheme === "dark" ? "var(--gray-8, #343a40)" : theme.colors?.indigo?.[0]}
      {...params}
    >
      {children}
    </Flex>
  );
};
